export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["为...创建小部件"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["账户"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["生成"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支付"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支付金额"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功时的操作"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["失败时的操作"])}
}